import { createContext, ReactElement, ReactNode, useContext } from 'react';

import useEmergencyAlarm, { IEmergencyAlarmProviderHook } from '../hooks/emergency-alarm-hook';

const EmergencyAlarmContext = createContext<IEmergencyAlarmProviderHook>({} as IEmergencyAlarmProviderHook);

export type EmergencyAlarmProviderProps = {
  children: ReactNode;
};

const EmergencyAlarmProvider = ({ children }: EmergencyAlarmProviderProps): ReactElement => (
  <EmergencyAlarmContext.Provider value={useEmergencyAlarm()}>{children}</EmergencyAlarmContext.Provider>
);

const useEmergencyAlarmContextProvider = (): IEmergencyAlarmProviderHook => useContext<IEmergencyAlarmProviderHook>(EmergencyAlarmContext);

export { EmergencyAlarmProvider, useEmergencyAlarmContextProvider };
